import { Component, Input } from '@angular/core';

import { SearchActivityEvents } from 'generated/graphql';

@Component({
  selector: 'app-new-entity-event',
  templateUrl: './new-entity-event.component.html'
})

export class ASNewEntityEventComponent {

  @Input() item: SearchActivityEvents.Node;
  /**
   *
   */
  constructor(
  ) {
  }

}
